import _ from 'lodash'
import buildUrl from 'build-url'

import Utils from '@/utils/utils'
import SVGHelper from '@glass-designer/helpers/svgHelper'

import { InventoryStockTypes, UOMTypes } from '@/store/types'

export default {
  methods: {

    /**
     * Goes through all the nested order items in the order & generates the SVG display data diagrams for standard glass
     * that are not generated by the order editor. Eg, just rectangles
     * Adds in the symbols for edgework too
     * Does not update order items generated by order editor
     * Applied to the flattened OrderItems edited by OrderItemList component
     * Mutates the OrderItemList in-place with the svgDisplayData field
     * 
     * Note: generateOrderItemStandardEdgeworkDetails() from OrderItemMixin MUST be run before this function to calculate edgework details per glass item
     * 
     * @param {Array<Object>} orderItemList - Array of objects containing the order item list
     * @param {Object} orderStampConfig - Object containing order stamp configuration details
     */
    generateOrderItemStandardDiagrams(orderItemList, orderStampConfig = {}) {
      let glassItems = orderItemList.filter(orderItem => {
        if(orderItem.stockType != InventoryStockTypes.glass)
          return false
        if(orderItem.isCancelled)
          return false
        return !orderItem.isEditorGeneratedItem
      })

      if(glassItems.length == 0)
        return

      glassItems.forEach(glassItem => {

        let childOrderItems = orderItemList.filter(orderItem => {
          return orderItem.parentOrderItemId == glassItem.id
        })
        let edgeworkDetailsList = glassItem.edgeworkDetailsList || []

        // Calculate SVG
        let svgHelper = new SVGHelper()
        glassItem.svgDisplayData = svgHelper.generateRectangleSVG({
          width: glassItem.glassWidth,
          height: glassItem.glassHeight,
          edgeworkDetailsList: edgeworkDetailsList,
          childOrderItems: childOrderItems
        }, {
          showDimensions: true,
          showEdgeworkLegend: true,
          showSquareCorners: true,
          showEdgeworkHighlights: true,
          showPanelItems: true,
          showAnchors: true,
          svgHeight: '240px',
          scaleMaxWidth: 720,
          scaleMaxHeight: 240,
          orderStampConfig: orderStampConfig
        })

        // Label SVG with less info
        svgHelper.setPadding(1, 1, 1, 1)
        glassItem.svgLabelData = svgHelper.generateRectangleSVG({
          width: glassItem.glassWidth,
          height: glassItem.glassHeight,
          edgeworkDetailsList: [],
          childOrderItems: childOrderItems
        }, {
          showDimensions: false,
          showEdgeworkLegend: false,
          showSquareCorners: true,
          centerDiagram: true,
          svgHeight: '240px',
          scaleMaxWidth: 240,
          scaleMaxHeight: 240
        })

        // Generate the label SVG corner data
        // Shows square corners & stamp position
        glassItem.svgLabelCornerData = svgHelper.generateRectangleCornerDataSVG({
          width: glassItem.glassWidth,
          height: glassItem.glassHeight,
          childOrderItems: childOrderItems
        }, {
          svgHeight: '240px',
          scaleMaxWidth: 240,
          scaleMaxHeight: 240,
          orderStampConfig: orderStampConfig
        })
      })
    }

  }
}